import type { ReactNode } from 'react';
import React, { createContext, useContext } from 'react';

export interface NavigationOptions {
  scroll?: boolean;
  withoutNavigationState?: boolean;
}

export interface Router {
  isNavigating: boolean;
  push: (url: string, options?: NavigationOptions) => void;
  replace: (url: string, options?: NavigationOptions) => void;
}

interface RouterProviderProps {
  router: Router;
  children: ReactNode;
}

const RouterContext = createContext<Router | null>(null);

const RouterProvider = ({ router, children }: RouterProviderProps) => {
  return <RouterContext.Provider value={router}>{children}</RouterContext.Provider>;
};

export const useRouter = (): Router => {
  const context = useContext(RouterContext);

  if (context === null) {
    throw new Error('useRouter must be used within a RouterProvider');
  }

  return context;
};

export default RouterProvider;
